export const dashboardTagTypes: DashboardTagType[] = ["TreeData"];
export type DashboardTagType = "TreeData";
export const forecastTagType: ForecastTagType[] = ["ForecastComparison"];
export type ForecastTagType = "ForecastComparison";
export type EnergyReading = {
  datetime: string;
  reading_type: ReadingTypeString;
  total: number;
  total_cost: number;
};
export type ProcessedReading = {
  status: string; // Status of the reading (e.g., "Generating", "IDLE")
  details: string; // Energy details in kWh
};
export type AggregationLevelOption = {
  label: string;
  value: AggregationLevel;
};
export type ReadingTypeString = "SolarGeneration" | "GridConsumption" | "GridExport";
export type AggregationLevel = "hourly" | "daily" | "monthly" | "yearly";
export type MetricType = "energy" | "cost";
export type EntityType = "customer" | "site" | "location" | "meter";

export interface EntityStatusError {
  id: string;
  issue: string;
  path: string;
}

export type FetchMeterReadingsRequest = {
  aggregation_level: AggregationLevel;
  entity_id: string;
  entity_name: string;
  from_date: string;
  to_date: string;
  totals_only?: boolean;
};
export type TransformedData = {
  date: string;
  grid: number;
  solar: number;
  export: number;
};

export interface TreeItemDataOut {
  id: string;
  entityType: EntityType | null;
  entityId: number | null;
  status: { issue: string; id: string; path: string }[];
  type?: string;
  path: string;
  name?: string;
  children?: TreeItemDataOut[];
}

export interface TreeViewProps {
  data: TreeItemDataOut[];
}

export interface TreeItemData {
  id: number;
  status?: string;
  type?: string;
  name: string;
  children?: TreeItemData[];
}

export interface TreeItemDataList {
  results: TreeItemData[];
}
